import { Component, EventEmitter, Input, OnChanges, Output, ViewChildren } from '@angular/core';
import { DataSheetImportDef, DataSheetIP, SalesOrder, SaveStatusObj, UserType } from '../../../shared/misc-classes';
import { ActivatedRoute } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DataService } from '../../../shared/dataservice.service';
import { DsExportService, DsExportHeaderInfo } from '../../../shared/ds-export.service';
import { MatLegacyTabChangeEvent as MatTabChangeEvent } from '@angular/material/legacy-tabs';
import { DataSheetImportDialog } from '../../../dialogs/data-sheet-import-dialog/data-sheet-import-dialog';

@Component({
  selector: 'data-sheet',
  templateUrl: './data-sheet.component.html',
  styleUrls: ['./data-sheet.component.css']
})
export class DataSheetComponent implements OnChanges {


  selectedIndex = 0;
  @Input() soLockObtained!:boolean;
  
  @Input() soObj!: SalesOrder;
  @Input() dataSheetObj!: DataSheetIP;
  @Output() updateSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  @Output() deleteDatasheet:  EventEmitter<SaveStatusObj> = new EventEmitter();

  disableForm: boolean = true;
  readonlyAccess: boolean = false;
  inputDisableMessage: string = 'This form is not yet enabled';

  landingPage: string = '';
  subSoNo!: string;
 
  @ViewChildren('stepper') stepper: any;

  selectedDepartmentIndex = 0;
  dsObj!: DataSheetIP;
  accessLevel: Array<UserType> = [];


  constructor(private route: ActivatedRoute, public dialog: MatDialog, public _dataService: DataService, private _dsExportService: DsExportService) { }
 
  get isLockObtained():boolean{
    return this.soLockObtained;
  }
  
ngOnChanges(){
  this.dsObj = this.dataSheetObj;
  this.disableForm = true;
  let _currentUserId = this._dataService.userId;
  let _elecEnggId = this._dataService.getElecDesignEngineerEmailId(this.soObj.marketingIP.mktElectricalDesignEngineerId);
  let _mechEnggId = this._dataService.getMechDesignEngineerEmail(this.soObj.marketingIP.mktMechanicalDesignEngineerId);
  let _pmId = this._dataService.getProjectManagerEmailId(this.soObj.marketingIP.projectManagerId);
  if(_currentUserId == _elecEnggId || _currentUserId == _mechEnggId || _currentUserId == _pmId){
    this.accessLevel.push(this._dataService.userType);
  }
  this.accessLevel.push(UserType.SUPER_ADMIN, UserType.MARKETING, UserType.HOD_MARKETING); // ONLY these users can edit Datasheets in SO Level
    if(this.soLockObtained == false){
      this.inputDisableMessage = "You can't Edit";
    }
    else if (!this.dataSheetObj.isInputEnabled) {
      this.inputDisableMessage = "This form is not yet enabled";
    }
    else if (!this.dataSheetObj.isDatasheetEditable) {
      this.inputDisableMessage = "This form is LOCKED and is NOT EDITABLE.";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
    }
    if(this._dataService.hasReadOnlyAccess){
      this.readonlyAccess = true;
    }
}
dataSheetStepChange(_ent: any){
  // console.log(_ent.selectedIndex)
  this.selectedDepartmentIndex = _ent.selectedIndex
}

  updateDS(_evnt:SaveStatusObj,_indx:number){
    if(this.updateSalesOrder){
      this.selectedIndex = _indx;
      _evnt.ssoIndex = _indx;
      this.updateSalesOrder.emit(_evnt);
    }
    
  }

  // Need this later
  // getStatusCSS(_status: FunctionStatus): string {
  //   if (_status == FunctionStatus.WAITING_FOR_PREV) {
  //     return "tab-legend white-legend";
  //   }
  //   if (_status == FunctionStatus.WAITING_FOR_USER_INPUT) {
  //     return "tab-legend grey-legend";
  //   }
  //   if (_status == FunctionStatus.SUBMITTED_INCOMPLETE) {
  //     return "tab-legend yellow-legend";
  //   }
  //   if (_status == FunctionStatus.SUBMITTED_COMPLETE) {
  //     return "tab-legend green-legend";
  //   }
  //   if (_status == FunctionStatus.SUBMITTED_WAITING_RESPONSE) {
  //     return "tab-legend blue-legend";
  //   }
  //   if (_status == FunctionStatus.NOT_SUBMITTED_BUT_READY) {
  //     return "tab-legend yellow-legend";
  //   }
  //   return "tab-legend white-legend";
  // }

  dataSheetTabChanged(_evnt:MatTabChangeEvent){
    this.selectedDepartmentIndex = 0;
    this.selectedIndex = _evnt.index;
  }

  // This function needs to be changed to Adding different Datasheets formats
  
  // getExisitingDataSheetList():Array<DatasheetNumbers>{
  //   let dsIdList:Array<string> = [];
  //   this.DSList.forEach((_ds:DataSheetIP) => {
  //     dsIdList.push(_ds.dataSheetId);
  //   });
  //   return this._dataService.datasheetNumbers.filter((_subOrdNum:DatasheetNumbers) => {
  //     return dsIdList.indexOf(_subOrdNum.datasheetNumbersId) >= 0;
  //   });
  // }

  public getSubOrderEnable():boolean{

    return this.soObj.isSubOrdesEnabled;
  }
  importSerialData(){
      var sDataArray:Array<DataSheetImportDef> = [];
      let _pType = this.dataSheetObj.dataSheetType;
      let dialogRef = this.dialog.open(DataSheetImportDialog, {
        width: '75%',
        data: {sDataArray: sDataArray, productType: _pType},
      });
      dialogRef.afterClosed().subscribe((confirm) => {
        if(confirm == true){
          sDataArray.forEach((_sNo:DataSheetImportDef) => {
            this.dataSheetObj.addDataSheetImport(_sNo);
            
          });
        }
      });
    }

    exportDatasheet(): void {
      const mkt = this.dsObj.parentSORef.marketingIP;
      const headerInfo: DsExportHeaderInfo = {
        formatNo: 'EPMV-AIS-HOM-001',
        customerName: mkt.customerName || '',
        projectName: mkt.projectName || '',
        switchboard: '',
        abbReference: mkt.salesOrderNo || ''
      };
      this._dsExportService.exportDatasheet(headerInfo, this.dsObj);
    }

    exportForCustomer(): void {
      const mkt = this.dsObj.parentSORef.marketingIP;
      const headerInfo: DsExportHeaderInfo = {
        formatNo: 'EPMV-AIS-HOM-001',
        customerName: mkt.customerName || '',
        projectName: mkt.projectName || '',
        switchboard: '',
        abbReference: mkt.salesOrderNo || ''
      };
      this._dsExportService.exportForCustomer(headerInfo, this.dsObj);
    }
  }

